export function getFormattedCalendarForDayOff ({ dayOff, holiday }) {
  return Array.from(new Set(dayOff.concat(holiday).map(elem => elem.date))).map(elem => ({
    date: new Date(elem)
  }))
}
